/**
 * Page Constants
 * 
 * @author Jan Windelle Manalaysay
 * @date 2018/09/07
 */

export const Pages = Object.freeze({
   DASHBOARD   : '/dashboard',
   GRAPH       : '/graph',
});

export const Orientations = Object.freeze({
   PORTRAIT    : 'portrait'
   , LANDSCAPE : 'landscape'
});


// WEBPACK FOOTER //
// ./src/pages/PageConstants.js